<script setup>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import TextDialog from '@/components/TextDialog.vue'
  import { Consts } from '@/components/logics/Consts'
  import { marked } from 'marked'
  import { ref, inject, onMounted } from 'vue'
  import { useRouter, RouterLink, RouterView } from 'vue-router'
  const router = useRouter()
  const consts = Consts()

  // ルーターからテナントIDを取得
  const tenantId = router.currentRoute.value.params.tenantId

  const breadcrumbs = [{ name: 'ダッシュボード', url: 'dashboard' }, { name: '利用規約' }]

  // App.vueから提供された変数を取得
  // const apiRequest = inject('apiRequest')
  const appData = inject('appData')

  // 変数
  let appDataValue = null

  // UI用変数
  const termsValue = ref()

  // ページデータ取得
  const getPageData = async () => {
    // Constsから利用規約を取得して上書き
    termsValue.value = marked.parse(consts.terms().text)
  }

  onMounted(async () => {
    if (!appData.data.value) {
      await appData.refresh(tenantId)
    }

    appDataValue = appData.data.value

    await getPageData()
  })
</script>

<template>
  <Header />
  <main class="app-main">
    <div class="main-header">
      <h2>利用規約</h2>
    </div>
    <div class="main-body">
      <div class="terms-content">
        <div class="markdown scroller" v-html="termsValue"></div>
      </div>
    </div>
  </main>
  <Footer :breadcrumbs="breadcrumbs" />
</template>

<style lang="less" scoped></style>
